
class ReduceMotionDetector extends HTMLElement {
    constructor() {
        super();
        this.motionReduced = false;
    }

    connectedCallback() {
        this.checkAndListenForReduceMotion();
    }

    checkAndListenForReduceMotion() {
        const motionMatchMedia = window.matchMedia('(prefers-reduced-motion)');
        this.motionReduced = motionMatchMedia.matches;
       
        // Initial check
        setTimeout(() => {
             this.dispatchReduceMotionEvent();
        }, 2000)

        // Listen for changes
        motionMatchMedia.addEventListener('change', () => {
            this.motionReduced = motionMatchMedia.matches;
            this.dispatchReduceMotionEvent();
        });
    }



    dispatchReduceMotionEvent() {
        // Dispatch event with the current reduced motion setting
        this.dispatchEvent(new CustomEvent('checkReduceMotionSetting', {
            detail: { isMotionReduced: this.motionReduced}
        }));
    }
}

customElements.define('reduce-motion-checker', ReduceMotionDetector);